module.exports = __webpack_public_path__ + "assets/_card-3.c31a61f8.svg";